import { motion, useTransform } from "framer-motion";
import { useState } from "react";

export default function ReachOut({ scrollY }) {

    const m = window.innerWidth < 768;
    const h = window.innerHeight * 3
    const h2 = window.innerHeight * 2

    const y = useTransform(scrollY, [0, h - 100, h], [ h2, 60, 0], {
        clamp: false
    })

    const opacity = useTransform(scrollY, [0, h - 100, h], [0, 0.5, 1], {
        clamp: false
    })

    const [data, setData] = useState({
        "first-names": "",
        "last-names": "",
        "email": '',
        "message": ""
    })

    function onUpdate(e) {
        setData(c => ({
            ...c,
            [e.target.name]: e.target.value
        }))
    }

    function onSendMessage(e) {

        e.preventDefault()
    }

    return (
        <>
            <motion.div id="reach-out" style={{ zIndex: 5, backgroundColor: '#000' }} className="flex centerX">
                {/* <motion.img
                    alt="by AltumCode on Unsplash"
                    src={photoB}
                    style={{
                        position: 'absolute',
                        top: 0,
                        width: "100%",
                        height: "100vh",
                        zIndex: -1,
                        objectFit: 'cover'
                    }}
                /> */}
                <motion.div id="contact-form" className={m ? "" : 'flex row centerX between'}>
                    <div style={{ color: "#fff", textAlign: m ? "center" : "left", marginTop: m ? 50 : 0 }}>
                        <p style={{ fontSize: 30 }}>Got Questions?</p>
                        <h1 style={{ fontSize: m ? 40 : 90 }}>Reach Out</h1>
                    </div>
                    <motion.form style={{ y: m ? 0 : y, opacity: m ? 1 : opacity }} noValidate onSubmit={onSendMessage} id="form-card">
                        <div className={m ? "" : "flex row"}>
                            <div>
                                <label>First Names</label>
                                <input name="first-names" value={data["first-names"]} 
                                    onChange={onUpdate}
                                />
                            </div>
                            {m && <br />}
                            <div>
                                <label>Last Name</label>
                                <input name="last-names" onChange={onUpdate} value={data["last-names"]} />
                            </div>
                        </div>
                        <br/>
                        <div>
                            <label>Your Email</label>
                            <input name="email" onChange={onUpdate} value={data.email} />
                        </div>
                        <br/>
                        <div>
                            <label>Leave A Message...</label>
                            <textarea name="message" onChange={onUpdate} value={data.message}  />
                        </div>
                        <br/>
                        <div>
                            <button type="submit" style={{ width: '100%', backgroundColor: '#000', color: '#fff' }}>Submit</button>
                        </div>
                    </motion.form>
                </motion.div>
            </motion.div>
        </>
    )
}